import React from "react";
import { useTranslation } from "react-i18next";
import { useWorkflow } from "../../workflow/WorkflowContext";
import { CalculatePanel } from "../../components/CalculatePanel";
import { LockedCalcNote } from "../../components/LockedCalcNote";
import { ReconciliationBanner } from "../../components/ReconciliationBanner";
import { PeriodMismatchBanner } from "../../components/PeriodMismatchBanner";
import { PeriodCoverageBanner } from "../../components/PeriodCoverageBanner";

/** Step 3 — Calculate. v0.6 nav refactor: dedicated route component. */
export default function Step3Calculate() {
  const { state, calc, setActiveStep } = useWorkflow();
  const { t } = useTranslation();
  return (
    <section data-testid="step-3-calculate" className="space-y-3">
      <LockedCalcNote calc={calc} step={3} />
      <CalculatePanel />
      {calc && state.steps[3].complete && (
        <div className="flex items-center gap-3">
          <button type="button" data-testid="step-3-continue"
            onClick={() => setActiveStep(4)}
            className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-4 py-2 text-xs rounded-xl">
            {t("ui.dashboard.continue_to_step", { idx: 4, label: t("ui.stepper.step4") })}
          </button>
        </div>
      )}
      {calc && <ReconciliationBanner recon={calc.reconciliation} />}
      {calc && <PeriodMismatchBanner calc={calc} />}
      {calc && <PeriodCoverageBanner calc={calc} />}
    </section>
  );
}
